import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import ParkingPartnerFields from './ParkingPartnerFields'

export const ParkingPartnerEdit = props => {
    return (<Edit {...props}>
            <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
                <Grid container spacing={8}>
                    <ParkingPartnerFields/>
                </Grid>
            </SimpleForm>
        </Edit>
    )
}

export default ParkingPartnerEdit